export var TagCssClass;
(function (TagCssClass) {
    TagCssClass["Base"] = "iress-tag";
    TagCssClass["DeleteButton"] = "iress-tag__delete-button";
    TagCssClass["Text"] = "iress-tag__text";
})(TagCssClass || (TagCssClass = {}));
//# sourceMappingURL=tag.types.js.map